import { render, staticRenderFns } from "./Howitworks.vue?vue&type=template&id=a0e4cbea"
import script from "./Howitworks.vue?vue&type=script&lang=js"
export * from "./Howitworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports